var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 867,
    height: 865,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1645,
    y: 137,
    width: 867,
    height: 865
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1645 -137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2176.5 262.5C2173.51 264.778 2170.71 267.26 2168.12 269.946 2163.3 274.937 2160.88 277.441 2160.86 277.458 2144.4 293.358 2128.28 309.372 2112.5 325.5",
    stroke: "#E9E9E9",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2112.5 325.5C2106.51 331.532 2100.6 337.389 2094.77 343.071 2094.4 343.421 2093.85 343.805 2093.12 344.225 2092.51 344.566 2091.96 344.982 2091.47 345.471 2009.15 427.566 1926.93 509.743 1844.79 592.004 1844.08 592.711 1842.9 593.708 1841.23 594.993 1840.11 595.859 1838.95 596.891 1837.74 598.088 1786.77 648.703 1735.93 699.458 1685.22 750.353 1684.04 751.542 1683.47 752.591 1683.5 753.5",
    stroke: "#FFC196",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.5 753.5 1655.5 935.5",
    stroke: "#FFE7BE",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.22 935.5 1646.51 999.796C1646.45 1000.13 1646.67 1000.44 1647 1000.49 1647.06 1000.5 1647.12 1000.5 1647.18 1000.49L1710.5 990.432",
    stroke: "#A09599",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.5 990.5C1768.78 981.877 1827.04 973.117 1885.29 964.22 1889.43 963.589 1892.17 963.016 1893.5 962.5",
    stroke: "#FFE7BE",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1893.5 962.989 1893.98 963.37C1894.25 963.578 1894.64 963.533 1894.91 963.264L2091.4 766.228C2091.66 765.956 2092.05 765.763 2092.5 765.677 2093.61 765.45 2094.51 764.903 2095.2 764.037 2096.05 762.987 2096.5 762.436 2096.55 762.383 2152.08 706.579 2207.74 650.909 2263.54 595.376 2263.74 595.175 2264.03 594.965 2264.43 594.746 2264.76 594.562 2265.06 594.339 2265.32 594.077 2284.75 574.915 2304.14 555.723 2323.5 536.5",
    stroke: "#FFC196",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2323.5 536.5 2387.5 473.5",
    stroke: "#E9E9E9",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2387.4 473.5C2419.97 441.037 2452.52 408.548 2485.05 376.033 2491.25 369.835 2495.45 365.291 2497.65 362.402 2506.25 351.082 2510.54 338.852 2510.5 325.711 2510.46 312.657 2506.76 300.983 2499.39 290.687 2497.34 287.824 2491.39 281.433 2481.53 271.514 2444.72 234.499 2407.81 197.584 2370.79 160.771 2363.82 153.828 2358.18 149.096 2353.89 146.575 2343.84 140.665 2332.96 137.999 2321.26 138.577 2305.85 139.33 2292.35 145.498 2280.78 157.08 2246.17 191.749 2211.54 226.405 2176.89 261.048 2176.63 261.311 2176.5 261.635 2176.5 262.02",
    stroke: "#FC97B0",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2387.5 473.5 2176.5 262.5",
    stroke: "#E6819A",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2323.5 536.5C2323.39 536.099 2323.02 535.581 2322.39 534.945 2252.51 465.117 2182.54 395.303 2112.5 325.5",
    stroke: "#E9AB80",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1893.5 962.5C1892.58 961.298 1890.92 959.492 1888.51 957.079 1820.8 889.589 1753.09 822.1 1685.39 754.61 1684.67 753.905 1684.04 753.535 1683.5 753.5",
    stroke: "#FFA855",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.5 990.5C1690.17 970.448 1672.72 952.857 1658.15 937.728 1657.12 936.647 1656.23 935.905 1655.5 935.5",
    stroke: "#A07C57",
    strokeWidth: 2.61864,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2386.9 473 2176 261.52C2176 261.135 2176.13 260.81 2176.39 260.548 2211.04 225.905 2245.67 191.249 2280.28 156.58 2291.85 144.998 2305.35 138.83 2320.76 138.077 2332.46 137.499 2343.34 140.165 2353.39 146.074 2357.68 148.596 2363.32 153.328 2370.29 160.27 2407.31 197.084 2444.22 233.999 2481.03 271.014 2490.89 280.933 2496.84 287.324 2498.89 290.187 2506.26 300.483 2509.96 312.157 2510 325.211 2510.04 338.352 2505.75 350.582 2497.15 361.902 2494.95 364.791 2490.75 369.335 2484.55 375.533 2452.02 408.048 2419.47 440.538 2386.9 473Z",
    fill: "#A53AFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175.77 262 2387 472.369 2323.44 536C2323.32 535.599 2322.95 535.082 2322.32 534.446 2252.3 464.653 2182.19 394.875 2112 325.108 2127.72 308.953 2143.79 292.911 2160.19 276.983 2160.21 276.966 2162.62 274.458 2167.42 269.459 2170.01 266.768 2172.79 264.282 2175.77 262Z",
    fill: "#F3E5FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2111.82 325C2181.93 394.997 2251.95 465.005 2321.89 535.028 2322.52 535.666 2322.89 536.185 2323 536.588 2303.64 555.784 2284.24 574.95 2264.81 594.085 2264.55 594.347 2264.25 594.57 2263.92 594.753 2263.53 594.972 2263.23 595.182 2263.03 595.382 2207.22 650.839 2151.55 706.432 2096.01 762.16 2095.96 762.212 2095.51 762.763 2094.66 763.811 2093.97 764.676 2093.07 765.223 2091.96 765.449 2091.51 765.535 2091.13 765.727 2090.86 766L1894.35 962.765C1894.08 963.033 1893.68 963.077 1893.42 962.869L1892.93 962.489C1892.02 961.283 1890.35 959.471 1887.94 957.05 1820.26 889.334 1752.57 821.619 1684.89 753.903 1684.17 753.195 1683.54 752.824 1683 752.789 1682.97 751.881 1683.54 750.832 1684.72 749.643 1735.41 698.774 1786.23 648.043 1837.18 597.453 1838.38 596.256 1839.55 595.225 1840.66 594.36 1842.33 593.076 1843.52 592.079 1844.23 591.372 1926.33 509.152 2008.52 427.015 2090.8 344.961 2091.3 344.472 2091.85 344.056 2092.45 343.716 2093.18 343.296 2093.73 342.912 2094.1 342.562 2099.93 336.883 2105.84 331.029 2111.82 325Z",
    fill: "#FF822D",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.53 753C1683.07 753.036 1683.7 753.406 1684.42 754.113 1752.28 821.766 1820.14 889.417 1888 957.069 1890.41 959.487 1892.08 961.298 1893 962.503 1891.67 963.01 1888.93 963.572 1884.79 964.192 1826.58 972.93 1768.36 981.532 1710.11 990 1689.74 970.088 1672.26 952.621 1657.65 937.598 1656.62 936.525 1655.74 935.787 1655 935.385L1682.53 753Z",
    fill: "#FFCE7C",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.72 935C1656.45 935.404 1657.32 936.146 1658.34 937.226 1672.72 952.336 1689.94 969.904 1710 989.932L1646.68 999.994C1646.36 1000.04 1646.05 999.812 1646.01 999.482 1646 999.42 1646 999.358 1646.01 999.296L1655.72 935Z",
    fill: "#402A32",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.c57f08050220e7914e35b0870df50bc9.svg";
export { ForwardRef as ReactComponent };